import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/aps`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(puntoAcceso) {
    return apiClient.post(`${puntoAcceso.id}`, puntoAcceso)
  },

  eliminar(idPuntoAcceso) {
    return apiClient.delete(`${idPuntoAcceso}`)
  },

  guardar(puntoAcceso) {
    return apiClient.post('', puntoAcceso)
  },

  puntoAccesoJSON(idPuntoAcceso, params) {
    params = params || {}
    return apiClient.get(idPuntoAcceso+'.json', { params:params })
  },

  puntosAccesoJSON(params){
    params = params || {}
    return apiClient.get(`${API}/aps.json`, { params: params })
  },
}
